export default __webpack_public_path__ + "static/media/FrozenABC2_08.ad6d50d3.png";